var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full border border-primary-200 rounded-xl p-4 mt-2"},[_c('CommonDropzone',{attrs:{"mutation":_vm.mutation,"variables":_vm.variables,"maxFilesize":300,"acceptedFiles":".pdf"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }